// 轉盤剩餘次數不足

const CampaignSpinDisable = ({ onClose, isSpinning }) => {
    return (
        <>
            <p className="text-bd4n text-[#fff] leading-[180%]">
                輪盤啟動次數不足
                <br />
                需要完成指定任務獲取啟動次數
            </p>
            <a
                href="#tasks"
                onClick={onClose}
                className="max-w-[287px] w-full py-[10px] text-bd1b text-[#fff] mx-auto mt-[19px] mb-[12px] block
                border-1 border-[#fff] border-opacity-[.52] rounded-[40px] trans hover:bg-[#0083A0] [@media(max-width:388px)]:py-[7px]"
            >
                點擊查看完成任務列表
            </a>
            <p className="text-bd3n text-[#fff] mb-[50px]">點擊表示已閱畢活動條款與隱私權條款</p>
            <button
                onClick={onClose}
                className={`px-[35px] py-[6px] rounded-[4px] text-bd4n text-[#fff] bg-[#fff] bg-opacity-[.11]
                ${isSpinning ? 'cursor-not-allowed' : ''}`}
            >
                關閉
            </button>
        </>
    );
};

export default CampaignSpinDisable;
